import { Badge } from 'twyne-new.ui';

import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function BuilderFormatter({ info }) {
  const { value } = getInfo(info)

  const color = {
    inactive: 'danger',
    draft: 'warning',
    published: 'success',
  }

  const status = !value?.version ? 'inactive' : value?.version === value?.publishVersion ? 'published' : 'draft'

  return <Badge variant='outline' color={color[status]}>
    {status}
  </Badge>
}
